import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
    const [menuExtended, setMenuExtended] = useState(() => window.innerWidth > 1000);

    const handleMenuButtonClick = () => {
        setMenuExtended(!menuExtended);
    };

    const environmentText = process.env.REACT_APP_ENV === 'production'
    ? ''
    : 'Testumgebung';

    // Access the global domain based on the environment
    const domain = process.env.REACT_APP_DOMAIN_WORDPRESS; // Get domain from environment variable

  return (
    <header className="py-4 sticky-top" style={{}}>
      <div className="container" style={{ maxWidth: '80%' }}>
        <div className="row header-row">
          <div className="col-md-1"><span style={{ color: 'red' }}>{environmentText}</span></div>
          <div className="col-md-4 align-self-center">
            <a href={`${domain}`}>
              <img
                style={{ height: 70 }}
                src={`${domain}/wp-content/uploads/2020/04/wohnfinanzierung_Logo_web_rgb_tranparent.png`}
                alt="Wohnfinanzierung Logo"
              />
            </a>
            <a onClick={handleMenuButtonClick} className="header-button">
              <FontAwesomeIcon
                size="lg"
                icon={faBars}
                style={{ position: 'absolute', right: '20%', top: '40%' }}
              />
            </a>
          </div>

          {/* Links will be conditionally rendered based on the menuExtended state */}
          {menuExtended && (
            <>
              <div className="col-md-auto align-self-end header-link">
                <a href={`${domain}/#leistungen`}>
                  <h3>
                    <b>Unsere Leistungen</b>
                  </h3>
                </a>
              </div>
              <div className="col-md-auto align-self-end header-link">
                <a href="#">
                  <h3>
                    <b>Kreditrechner</b>
                  </h3>
                </a>
              </div>
              <div className="col-md-auto align-self-end header-link">
                <a href={`${domain}/wohnfinanzierung`}>
                  <h3>
                    <b>Über uns</b>
                  </h3>
                </a>
              </div>
              <div className="col-md-auto align-self-end header-link">
                <a href={`${domain}/kontakt`}>
                  <h3>
                    <b>Kontakt</b>
                  </h3>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
